import React, { useEffect } from "react";
import Loader from "../../../components/shared/loader/Loader";
import { trackGANativeApp } from "../../../constants/AppMethod";
import { LOCALSESSIONDATAKEYS, NativeAPP_GAEvents } from "../../../constants/AppConstants";
import { useDispatch, useSelector } from "react-redux";
import { getDeviceRegitration } from "../../../actions/SelectDevice";
import { getLocalSessionData } from "../../../utils/Authentication/handleUserSession";
import ErrorPage from "../../../components/shared/errorPage/ErrorPage";
import { useAppNavigation } from "../../../utils/CustomHooks/useAppNavigation";

const HwIncRegisterService = (props) => {
    const dispatch = useDispatch();
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const deviceID = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const deviceRegistrationResult = useSelector((state) => state.DeviceRegistration)
    const subscriptionKind = props?.location?.state || {};
    const { goToWebPlaceOrder } = useAppNavigation();

    useEffect(() => {
        trackGANativeApp(NativeAPP_GAEvents.HWINC_POST_ENROLLMENT);
        dispatch(getDeviceRegitration(UID, deviceID));
        // eslint-disable-next-line
    }, [dispatch]);

    useEffect(() => {
        if(deviceRegistrationResult.success){
            goToWebPlaceOrder({subscriptionKind})
        }
        // eslint-disable-next-line
    }, [deviceRegistrationResult.success]);

    if(deviceRegistrationResult.error){
      return (
        <ErrorPage errorInfo={deviceRegistrationResult.error}></ErrorPage>
      )
    }

    return (
       <Loader />
    );
}

export default HwIncRegisterService;